<div
  id="inspection-point-data"
  [style.width]="overlayWidthPixels + 'px'"
  [style.margin-left]="calculateMarginLeft() + 'px'"
  [style.margin-top]="calculateMarginTop() + 'px'"
  [style.left]="calculateLeft() + 'px'"
  [style.top]="calculateTop() + 'px'"
  #container
>
  <div class="data-point-table">
    <div class="data-point-table-row border-row">
      <div class="data-point-table-cell heading-cell">{{"Drawings.Equipment:" | i18next}}</div>
      <div class="data-point-table-cell data-cell">{{ drawingEquipmentData?.orgTreeNodeName }}</div>
    </div>
    <div class="data-point-table-row border-row">
      <div class="data-point-table-cell heading-cell">{{"Drawings.Criticality" | i18next}}</div>
      <div class="data-point-table-cell data-cell">
        <span [style.color]="drawingEquipmentData?.criticalityColor ? drawingEquipmentData.criticalityColor : '#000'">
          {{ getCriticality() }}
        </span>
      </div>
    </div>
    <div class="data-point-table-row border-row">
      <div class="data-point-table-cell heading-cell">{{"Drawings.LastInspectionDate" | i18next}}</div>
      <div class="data-point-table-cell data-cell">{{ getLastInspectionDate() }} {{ getThicknessReportTypeName() }}</div>
    </div>
    <div class="data-point-table-row">
      <div class="data-point-table-cell heading-cell">{{"Drawings.DueDate" | i18next}}</div>
      <div class="data-point-table-cell data-cell">
        {{ getDueDate() }}
      </div>
    </div>
  </div>
</div>
